import { supabase } from '../lib/supabase'

export const commentService = {
  schemaName: 'Tickets',
  tableName: 'comment',

  async getAll() {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select('*')
      if (error) throw error
      return { success: true, data, error: null }
    } catch (error) {
      console.error('Error fetching comments:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  async create(comment) {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .insert([comment])
        .select()

      if (error) throw error
      return { success: true, data: data[0], error: null }
    } catch (error) {
      console.error('Error creating comment:', error)
      return { success: false, data: null, error: error.message }
    }
  },
}
